module.exports = __webpack_public_path__ + "media/assets/community/mb-badge-25e3a316f9f5df31328ad286608603514c624cd684107afb1942b6b1abada169.png";